/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pagination1OfRegionDailyAverageAdminDto } from '../models/Pagination1OfRegionDailyAverageAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RegionDailyAveragesService {
    /**
     * **Required Policy:** `ViewDriverRankings`
     * @returns Pagination1OfRegionDailyAverageAdminDto OK
     * @throws ApiError
     */
    public static getRegionDailyAveragesAdmin({
        regionId,
        startDate,
        endDate,
        page,
        limit,
    }: {
        regionId?: number,
        startDate?: string,
        endDate?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfRegionDailyAverageAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/regiondailyaverages',
            query: {
                'regionId': regionId,
                'startDate': startDate,
                'endDate': endDate,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
